// extracted by mini-css-extract-plugin
export default {"goToBiggerScreen":"+bN0u","seeAllExpressions":"Bp-nm","seeAllExpressionsLink":"YUFU-","seeAllExpressionsLinkText":"BjekC","iframe":"CO3Yg","iframeHidden":"p16C3","title":"weGqz"};